@if(isAllTabsCompleted()) {
<button
  mat-flat-button
  type="button"
  (click)="onFinishAppointmentConfirmation()"
  [disabled]="isFinishingAppointment() || hasUnsavedChanges()"
>
  @if(isFinishingAppointment()) {
  <mat-spinner diameter="24"></mat-spinner>
  } @if(!isFinishingAppointment()) {
  <span>Finalizar consulta</span>
  }
</button>
}
